import React from 'react'
import {
  TOOTH_NUMBER,
  isToothNumberAllowedForArchetype,
  ToothSurfaceArchetype,
} from './Appointment.constant'

type ToothNumberGridProps = {
  selectedToothNums: ReadonlySet<number>
  toothSurfaceArchetype: ToothSurfaceArchetype
  onToothClick: (tooth: number) => void
}

const ToothNumberGrid: React.FC<ToothNumberGridProps> = ({
  selectedToothNums,
  toothSurfaceArchetype,
  onToothClick,
}) => {
  return (
    <div className="appt-tooth">
      {TOOTH_NUMBER.map((item, index) => {
        const toothNum = parseInt(item, 10)
        const isDisabled = !isToothNumberAllowedForArchetype(
          toothNum,
          toothSurfaceArchetype,
        )
        const isSelected = selectedToothNums.has(toothNum)
        return (
          <button
            type="button"
            key={index}
            className={`unstyled-button appt-tooth-item ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
            aria-disabled={isDisabled}
            aria-pressed={isSelected}
            disabled={isDisabled}
            onClick={() => {
              if (!isDisabled) {
                onToothClick(toothNum)
              }
            }}
          >
            {item}
          </button>
        )
      })}
    </div>
  )
}

export default ToothNumberGrid
